module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_7016.5bc8ef57.png";